import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-dashboard-error',
    standalone: false,
    templateUrl: './dashboard-error.html',
    styleUrls: ['./dashboard-error.css']
})
export class DashboardError {
    private static nextId = 0;

    @Input() errorMessage: string | null | undefined = '';
    @Input() heading = 'Çalışma alanınıza erişilemiyor';
    @Input() subtitle =
        'Bilgileriniz yüklenirken bir sorun oluştu. Anasayfaya dönebilir veya tekrar giriş yapabilirsiniz.';
    @Input() badgeText = 'Erişim tamamlanamadı';
    @Input() errorLabel = 'İşlem tamamlanamadı';
    @Input() homeUrl = '/';
    @Input() homeText = 'Anasayfaya Dön';
    @Input() loginText = 'Tekrar Login Ol';
    @Input() retryText = 'Tekrar Dene';
    @Input() showHomeButton = true;
    @Input() showLoginButton = true;
    @Input() retryEnabled = false;

    @Output() retryRequested = new EventEmitter<void>();
    @Output() loginRequested = new EventEmitter<void>();

    readonly headingId = `one-error-heading-${++DashboardError.nextId}`;
    readonly descriptionId = `${this.headingId}-description`;

    get displayMessage(): string {
        return (this.errorMessage ?? '').trim();
    }

    get isVisible(): boolean {
        return this.displayMessage.length > 0;
    }

    Retry(): void {
        this.retryRequested.emit();
    }

    GoToLogin(): void {
        // Logout ve yönlendirme, componenti kullanan sayfada yapılır.
        this.loginRequested.emit();
    }
}
